import { Directive, Renderer2, OnInit, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[gisDraggableWidget]',
    standalone: false
})
export class DraggableWidgetDirective implements OnInit {
  constructor(private _renderer: Renderer2, private _draggableWidget: ElementRef) {}

  @Input() dragHandle?: ElementRef;

  ngOnInit() {
    if (!this.dragHandle) this.dragHandle = this._draggableWidget.nativeElement;
    this.setMoveCursorOnDragHandle();
    this.enableDragging();
  }

  private setMoveCursorOnDragHandle() {
    this._renderer.setStyle(this.dragHandle, 'cursor', 'move');
  }

  private enableDragging() {
    const self = this;

    this._renderer.listen(this._draggableWidget.nativeElement, 'dragstart', event => {
      self.dragStart(event);
    });
    this._renderer.listen(this.dragHandle, 'mousedown', () => {
      this._renderer.setAttribute(this._draggableWidget.nativeElement, 'draggable', 'true');
    });
    this._renderer.listen(this.dragHandle, 'mouseout', () => {
      this._renderer.setAttribute(this._draggableWidget.nativeElement, 'draggable', 'false');
    });
  }

  /**
   * @function dragstart
   * @param event The event object containing dragged DOM element
   * @description Event triggers when dragging starts. Get computed style
   * and calculated clicked position X and Y. Create a transfer object
   * with the position and the Element ID and send to drop event
   *
   * Note : detach dragged element from angular cycle to prevent
   * angular from digging while moving (boost drag performance without lag)
   */
  private dragStart(event) {
    const computedStyle = window.getComputedStyle(event.target, null);
    let posX = parseInt(computedStyle.getPropertyValue('left')) - event.clientX;
    let posY = parseInt(computedStyle.getPropertyValue('top')) - event.clientY;
    if (isNaN(posX)) posX = 0 - event.clientX;
    if (isNaN(posY)) posY = 0 - event.clientY;
    const sourceElementId = event.target.id;
    const transferObject = JSON.stringify({
      x: posX,
      y: posY,
      sourceID: sourceElementId,
    });
    event.dataTransfer.setData('draggedElement', transferObject);
  }
}
